(function() {
    'use strict';

a3_cabin_reports.factory('BarTrolleyFactory', BarTrolleyFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name BarTrolleyFactory
    * @description 
    *   Manage Report's BarTrolley.
    * @ngInject
    */
function BarTrolleyFactory(GenericModalFactory) {

        /**
         * Initialiaze BarTrolley object 
         * @memberof BarTrolleyFactory
         */
		function BarTrolley() {
			this.Id = null;
			this.Position = null;
			this.SealFound = null;
            this.SealLeft = null;
            this.Label = 'Bar trolleys';
            this.Photos = [];
            this.PhotoRemarks = null;
		}

		var service = {
			createNew : createNew,
			fromObject : fromObject,
			deleteFromList : deleteFromList
		}
			
        /**
         * Create a new BarTrolley object 
         * @memberof BarTrolleyFactory
         * @returns {object} BarTrolley
         */
		function createNew() {
			return GenericModalFactory.createNew(BarTrolley)
		}
        
	 
        /**
         * Extend given BarTrolley object 
         * @memberof BarTrolleyFactory
         * @param {object} obj The BarTrolley object that will be extended
         * @returns {object} BarTrolley
         */
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,BarTrolley)
		}

        /**
         * Delete BarTrolley object from given list
         * @memberof BarTrolleyFactory
         * @param {object} obj The BarTrolley object that will be deleted
         * @returns {array} BarTrollies
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
		
		return service;
	}

})();